// frontend/src/components/DocumentViewer/ViewerControls.tsx

import React from "react";
import { Maximize2, ZoomIn, ZoomOut, RotateCcw, Download, RotateCw } from "lucide-react";

interface ViewerControlsProps {
  onFullscreen?: () => void;
  onZoomIn?: () => void;
  onZoomOut?: () => void;
  onResetZoom?: () => void;
  onDownload?: () => void;
  onRotate?: () => void;
  isFullscreenMode?: boolean;
  disabled?: boolean;
  canDownload?: boolean;
}

const ViewerControls: React.FC<ViewerControlsProps> = ({
  onFullscreen,
  onZoomIn,
  onZoomOut,
  onResetZoom,
  onDownload,
  onRotate,
  isFullscreenMode = false,
  disabled = false,
  canDownload = true,
}) => {
  const buttonClass = `p-2 rounded-lg transition-colors ${
    disabled
      ? "text-gray-300 cursor-not-allowed"
      : "hover:bg-gray-100/50 text-gray-600"
  }`;

  return (
    <div className="flex items-center gap-2 px-4 py-2 rounded-lg">
      {isFullscreenMode && (
        <>
          {onZoomOut && (
            <button
              onClick={!disabled ? onZoomOut : undefined}
              className={buttonClass}
              title="Zoom Out"
              disabled={disabled}
            >
              <ZoomOut size={20} />
            </button>
          )}
          {onResetZoom && (
            <button
              onClick={!disabled ? onResetZoom : undefined}
              className={buttonClass}
              title="Reset Zoom"
              disabled={disabled}
            >
              <RotateCcw size={20} />
            </button>
          )}
          {onZoomIn && (
            <button
              onClick={!disabled ? onZoomIn : undefined}
              className={buttonClass}
              title="Zoom In"
              disabled={disabled}
            >
              <ZoomIn size={20} />
            </button>
          )}
          {onRotate && (
            <button
              onClick={!disabled ? onRotate : undefined}
              className={buttonClass}
              title="Rotate"
              disabled={disabled}
            >
              <RotateCw size={20} />
            </button>
          )}
          {(onZoomIn || onZoomOut || onResetZoom || onRotate || (onDownload && canDownload)) && (
            <div className="w-px h-6 bg-gray-300 mx-2" />
          )}
          {onDownload && canDownload && (
            <button
              onClick={!disabled ? onDownload : undefined}
              className={buttonClass}
              title="Download"
              disabled={disabled}
            >
              <Download size={20} />
            </button>
          )}
        </>
      )}
      {onFullscreen && !isFullscreenMode && (
        <button
          onClick={!disabled ? onFullscreen : undefined}
          className={buttonClass}
          title="Fullscreen"
          disabled={disabled}
        >
          <Maximize2 size={20} />
        </button>
      )}
    </div>
  );
};

export default ViewerControls;
